import React from 'react';
import { RosterItem } from '../../../../../app/domain/Roster/RosterItem';
import Input from '../../../misc/field/Input';

interface Props {
  columnCfg: any;
  onChange: (item: RosterItem, cfg: any) => void;
  onClick?: (e: React.MouseEvent) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  rosterItem: RosterItem;
}

const TextInputColumn: React.FC<Props> = ({ columnCfg, onChange, onFocus, onBlur, rosterItem }) => {
  const field = columnCfg.field;
  const value = rosterItem[field] as string;
  const isNameField = columnCfg?.id === 'name';

  return (
    <td className={columnCfg.id}>
      <Input
        name="text_input_column"
        type="text"
        value={value}
        placeholder={isNameField ? '*Roster names are case sensitive' : undefined}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          if (newValue !== value) {
            rosterItem[field] = newValue;
            onChange(rosterItem, columnCfg);
          }
        }}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </td>
  );
};

export default TextInputColumn;
